import React from "react";
var __jsx = React.createElement;
import { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { useMemo } from "react";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import BrandGeneralInformation from "@/components/SearchComponent/SEOAboutSection/BrandGeneralInformation";
import BrandCommonQuestion from "@/components/SearchComponent/SEOAboutSection/BrandCommonQuestion";
import BrandInfo from "@/components/SearchComponent/SEOAboutSection/BrandInfo";
import PricesTable from "@/components/SearchComponent/SEOAboutSection/PricesTable";
import { If } from "@componentsShared/Conditional/If";
import FinancingPrices from "@/components/SearchComponent/SEOAboutSection/FinancingPrices";
import { useMatch } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
var SEOAboutSection = function SEOAboutSection() {
  var _useSearchResultsData = useSearchResultsData(),
    seoAboutData = _useSearchResultsData.seoAboutData,
    selectedOptions = _useSearchResultsData.selectedOptions,
    pricesTableData = _useSearchResultsData.pricesTableData,
    financingData = _useSearchResultsData.financingData,
    posts = _useSearchResultsData.posts,
    metaData = _useSearchResultsData.metaData;
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var isMakeModelRouteAr = useMatch("/autos/:make/:model");
  var isMakeModelRouteEn = useMatch("/en/autos/:make/:model");
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  // Generate dynamic titles based on make and model
  var makeName = useMemo(function () {
    var _seoAboutData$makeDat2;
    if (lang === 'ar') {
      var _seoAboutData$makeDat;
      return (seoAboutData === null || seoAboutData === void 0 ? void 0 : (_seoAboutData$makeDat = seoAboutData.makeData) === null || _seoAboutData$makeDat === void 0 ? void 0 : _seoAboutData$makeDat.name_ar) || "";
    }
    return (seoAboutData === null || seoAboutData === void 0 ? void 0 : (_seoAboutData$makeDat2 = seoAboutData.makeData) === null || _seoAboutData$makeDat2 === void 0 ? void 0 : _seoAboutData$makeDat2.name_en) || "";
  }, [seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.makeData]);
  var modelName = useMemo(function () {
    var _seoAboutData$modelDa2;
    if (lang === 'en') {
      var _seoAboutData$modelDa;
      return (seoAboutData === null || seoAboutData === void 0 ? void 0 : (_seoAboutData$modelDa = seoAboutData.modelData) === null || _seoAboutData$modelDa === void 0 ? void 0 : _seoAboutData$modelDa.name_en) || "";
    }
    return (seoAboutData === null || seoAboutData === void 0 ? void 0 : (_seoAboutData$modelDa2 = seoAboutData.modelData) === null || _seoAboutData$modelDa2 === void 0 ? void 0 : _seoAboutData$modelDa2.name_ar) || "";
  }, [seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.modelData, lang]);
  var isMakeSelected = useMemo(function () {
    return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.filterField) === 'make_id';
    })) !== undefined;
  }, [selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length]);
  var isModelSelected = useMemo(function () {
    return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.filterField) === 'model_id';
    })) !== undefined;
  }, [selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length]);
  var renderGeneralInfoContent = function renderGeneralInfoContent() {
    var content = seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.makeData;
    var modelContent = seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.modelData;
    if (isMakeSelected && !isModelSelected) {
      if (lang === "ar") {
        return content === null || content === void 0 ? void 0 : content.about_ar;
      }
      return content === null || content === void 0 ? void 0 : content.about_en;
    }
    if (lang === 'ar') {
      return modelContent === null || modelContent === void 0 ? void 0 : modelContent.about_ar;
    }
    return modelContent === null || modelContent === void 0 ? void 0 : modelContent.about_en;
  };
  // Transform price data to match PricesTable component format
  var transformedPricesData = useMemo(function () {
    if (!pricesTableData || pricesTableData.length === 0) {
      return [];
    }
    return pricesTableData.map(function (item, index) {
      return {
        id: index + 1,
        brand: item.title,
        lowest: item.min_price.toLocaleString(),
        highest: item.max_price.toLocaleString(),
        average: item.avg_price.toLocaleString(),
        link: item === null || item === void 0 ? void 0 : item.link
      };
    });
  }, [pricesTableData]);
  var generatePricesCtaLink = function generatePricesCtaLink() {
    var make = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.filterField) === 'make_id';
    });
    var model = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.filterField) === 'model_id';
    });
    var make_name = make === null || make === void 0 ? void 0 : make.name_en;
    var baseRoute = "/prices/";
    if (make && !model) {
      return createUrl(baseRoute + make_name);
    } else if (make && model) {
      var model_name = model === null || model === void 0 ? void 0 : model.name_en;
      return createUrl(baseRoute + make_name + "/" + model_name);
    }
  };

  // Transform financing data to match FinancingPrices component format
  var transformedFinancingData = useMemo(function () {
    var _financingData$financ;
    if (!(financingData !== null && financingData !== void 0 && financingData.finance_price)) {
      return null;
    }
    return {
      financing: {
        monthlyPayment: {
          label: tShort('pricing/monthly_installment', {
            ns: 'web_search'
          }),
          subtitle: tShort('pricing/start_from', {
            ns: 'web_search'
          }),
          value: financingData.finance_price.text,
          showPriceIcon: true
        },
        duration: {
          label: tShort('pricing/period', {
            ns: 'web_search'
          }),
          subtitle: tShort('pricing/month_count', {
            ns: 'web_search'
          }),
          value: financingData.finance_price.installment_period,
          unit: tShort('pricing/month', {
            ns: 'web_search'
          })
        },
        firstPayment: {
          label: tShort('pricing/down_payment', {
            ns: 'web_search'
          }),
          subtitle: tShort('pricing/start_from', {
            ns: 'web_search'
          }),
          value: financingData.finance_price.first_payment,
          showPriceIcon: true
        },
        finalPayment: {
          label: tShort('pricing/last_payment', {
            ns: 'web_search'
          }),
          subtitle: tShort('pricing/start_from', {
            ns: 'web_search'
          }),
          value: financingData.finance_price.last_payment,
          showPriceIcon: true
        },
        description: tShort("pricing/section_description", {
          ns: "web_search"
        }).replace('{model}', modelName).replace('{make}', makeName).replace('{financePrice}', financingData === null || financingData === void 0 ? void 0 : (_financingData$financ = financingData.finance_price) === null || _financingData$financ === void 0 ? void 0 : _financingData$financ.text).replace('{period}', financingData.finance_price.installment_period).replace('{firstPayment}', financingData.finance_price.first_payment).replace('{last_payment}', financingData.finance_price.last_payment).replace('{vatPrice}', financingData.vat_price.text)
      },
      cashPrice: {
        value: financingData.vat_price.text,
        disclaimer: tShort("pricing/disclaimer", {
          ns: 'web_search'
        })
      },
      title: tShort("pricing/section_title", {
        ns: "web_search"
      }).replace('{make}', makeName).replace('{model}', modelName)
    };
  }, [financingData, makeName, modelName, lang, tShort]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-about-section",
    className: "pb-4 max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-10"
  }, /*#__PURE__*/React.createElement(If, {
    condition: !!(seoAboutData !== null && seoAboutData !== void 0 && seoAboutData.makeData)
  }, /*#__PURE__*/React.createElement(BrandInfo, {
    title: tShort("brand/about", {
      ns: "web_search"
    }).replace("{make}", makeName).replace("{model}", modelName)
  })), /*#__PURE__*/React.createElement(If, {
    condition: transformedPricesData && transformedPricesData.length > 0
  }, /*#__PURE__*/React.createElement(PricesTable, {
    title: tShort("price/table_title", {
      ns: "web_search"
    }).replace("{make}", makeName).replace("{model}", modelName),
    data: transformedPricesData,
    ctaLink: generatePricesCtaLink()
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!transformedFinancingData && (!!isMakeModelRouteAr || !!isMakeModelRouteEn)
  }, /*#__PURE__*/React.createElement(FinancingPrices, {
    title: transformedFinancingData === null || transformedFinancingData === void 0 ? void 0 : transformedFinancingData.title,
    financing: transformedFinancingData === null || transformedFinancingData === void 0 ? void 0 : transformedFinancingData.financing,
    cashPrice: transformedFinancingData === null || transformedFinancingData === void 0 ? void 0 : transformedFinancingData.cashPrice
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(posts !== null && posts !== void 0 && posts.length) || !!(metaData !== null && metaData !== void 0 && metaData.productsCount)
  }, /*#__PURE__*/React.createElement(BrandCommonQuestion, {
    title: tShort("brand/questions_title", {
      ns: "web_search"
    }).replace("{make}", makeName).replace("{model}", modelName)
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!renderGeneralInfoContent()
  }, /*#__PURE__*/React.createElement(BrandGeneralInformation, {
    title: tShort("brand/general_info_title", {
      ns: "web_search"
    }).replace("{make}", makeName).replace("{model}", modelName),
    content: renderGeneralInfoContent()
  })))));
};
export default SEOAboutSection;